import React from 'react';
import DynamicWebServiceDrivenForm from "../../platform/webform/DynamicWebServiceDrivenForm";
import {StandardLayout} from "../../layout/StandardLayout";
import {Card} from "../../components/Card";
import {useNavigate, useParams} from "react-router";

export function EditIssuePage(props:{}) {
    const {id} = useParams();
    var navigate = useNavigate();

    return <>
        <Card header={"Edytuj sprawę"}>
            <DynamicWebServiceDrivenForm dslUrl={`/api/issue/edit/${id}/form`}
                                         submissionUrl={`/api/issue/edit/${id}/submit`}
                                         submitLabel="Zapisz"
                                         successHandler={() => {
                                             alert('Sprawa została zaktualizowana');
                                             navigate(`/show-issue/${id}`);
                                         }}/>
        </Card>
    </>
}
